<ion-card
  *ngIf="userServ.checkModule(appModule.Community)"
  routerLink="/app/community/detail-community/{{ community.id }}"
  routerLinkActive="router-link-active"
  class="community-tile__card"
  (click)="communityServ.idNavination = community.id"
>
  <div class="community-tile__content-container">
    <img
      [src]="community.image.filePath"
      *ngIf="community.image"
      [alt]="community.image.fileName"
      class="community-tile__image"
    />
    <ion-card-header>
      <ion-card-title>{{ community.title }}</ion-card-title>
      <p
        class="community-tile__description"
        *ngIf="!community.image"
        [innerHTML]="description"
      >
        <!-- {{ community.description }} -->
      </p>
    </ion-card-header>
    <ion-card-content>
      <p class="display-flex-important ion-justify-content-between">
        <span>
          {{ community.companyCreated.name }}
        </span>
        <span>
          {{ community.publishDate | dateSti }}
        </span>
      </p>
    </ion-card-content>
  </div>
</ion-card>
